import { render, staticRenderFns } from "./ProjectUserForm.vue?vue&type=template&id=294f4fe2&scoped=true&"
import script from "./ProjectUserForm.vue?vue&type=script&lang=js&"
export * from "./ProjectUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f4fe2",
  null
  
)

export default component.exports